import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { ApiStatusTypeEnum } from "../../../../enumeration/ApiStatusTypeEnum";
import { Overlay } from "../../../common/components/Overlay";
import * as actions from "../../redux/PromotionAction";

export const FreePromotionList = ({
  freeCreditCompanyLists,
  setItemId,
  itemId,
  promotionId,
  setSwalProps,
}) => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleClaim = (companycode) => {
    setIsLoading(true);
    dispatch(
      actions.creditClaim({
        action: "freecreditclaim",
        itemid: itemId,
        companycode,
        promotionid: promotionId,
      })
    ).then((resp) => {
      setIsLoading(false);
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({ id: "claimSuccessfully" }),
          onConfirm: () => {
            dispatch(
              actions.getPromotionDetail({
                action: "promotiondetailV2",
                promotionid: promotionId,
              })
            );
            setItemId(undefined);
          },
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <>
      {isLoading && <Overlay />}
      <Modal
        onHide={() => setItemId(undefined)}
        show={!!itemId}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        data-bs-theme="dark"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-white"
          >
            {intl.formatMessage({ id: "promotion" })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-white d-flex flex-column gap-2">
          {freeCreditCompanyLists?.map((freeCreditCompany) => (
            <div
              className={`rounded p-3 border`}
              style={{ cursor: "pointer" }}
              onClick={() => handleClaim(freeCreditCompany.companycode)}
            >
              <div className="fw-bold pb-2 mb-2 border-bottom">
                {freeCreditCompany.companyname}
              </div>
              <div>
                {freeCreditCompany.freeCreditCompanyTypes?.map(
                  (freeCreditCompanyType, index) => (
                    <div key={index}>
                      <div className="d-flex">
                        <div className="pe-2">
                          {intl.formatMessage({ id: "rollOver" })} :
                        </div>
                        <div>{freeCreditCompanyType.turnover}</div>
                      </div>
                      <div className="d-flex">
                        <div className="pe-2">
                          {intl.formatMessage({ id: "gameType" })} :
                        </div>
                        <div>{freeCreditCompanyType.gametype}</div>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          ))}
        </Modal.Body>
      </Modal>
    </>
  );
};
